import { KnowledgeQuickFilterScope } from "generated/CoreApi_v1";
import { useParams } from "react-router";
import { SelectionQuickFilter } from "views/knowledge/settings/Home/QuickFilter/SelectionQuickFilter";

export const EditChannelQuickFilters: React.FC = () => {
    const { channelId } = useParams();
    return <SelectionQuickFilter scope={KnowledgeQuickFilterScope.Channel} scopeRef={channelId} />;
};
